app.filter("nl2br",
    ['$filter',
        function ($filter) {
            return function (text) {
                text = text.replace(/\n/g, '<br />');
                return $filter.trustAsHtml(text);
            }
        }]);